export default __webpack_public_path__ + "static/media/conexoplus.8f9f5110.png";